import { useQuery } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopPurchasesService } from '@/modules/shop/api/services'
import type { paths } from '@/schema'

type PurchasesQuery =
	paths['/api/admin/shop/purchases']['get']['parameters']['query']
type PurchasesResponse =
	paths['/api/admin/shop/purchases']['get']['responses']['200']['content']['application/json']

const useQueryGetShopPurchases = (query?: PurchasesQuery) => {
	return useQuery<PurchasesResponse>({
		queryKey: SHOP_QUERY_KEYS.PURCHASES.LIST(query),
		queryFn: () => ShopPurchasesService.getShopPurchases(query),
	})
}

export default useQueryGetShopPurchases
